class AnnouncementBarVertical extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-viewport]');
    this.track = this.querySelector('[data-track]');
    if (!this.viewport || !this.track) return;

    this.originalSlides = Array.from(this.track.children).filter(el =>
      el.classList.contains('announcement-bar__slide')
    );

    if (this.originalSlides.length <= 1) {
      // Mesmo com 1 slide, ajusta altura pra não quebrar layout
      this.#syncHeight();
      return;
    }

    // evita duplicar se o theme editor re-hidratar
    if (this.track.dataset.inited === '1') return;
    this.track.dataset.inited = '1';

    // clones para loop infinito
    const first = this.originalSlides[0];
    const last = this.originalSlides[this.originalSlides.length - 1];

    this.cloneFirst = first.cloneNode(true);
    this.cloneLast = last.cloneNode(true);

    this.cloneFirst.setAttribute('data-clone', '1');
    this.cloneLast.setAttribute('data-clone', '1');

    this.track.insertBefore(this.cloneLast, first);
    this.track.appendChild(this.cloneFirst);

    this.slides = Array.from(this.track.children).filter(el =>
      el.classList.contains('announcement-bar__slide')
    );

    this.index = 1; // começa no primeiro “real”
    this.isAnimating = false;

    this.#syncHeight();
    this.#jumpTo(this.index);

    // setas (compatível com slideshow-arrows do tema)
    this.prevBtn = this.querySelector('.slideshow-control--previous');
    this.nextBtn = this.querySelector('.slideshow-control--next');

    if (this.prevBtn) this.prevBtn.addEventListener('click', (e) => { e.preventDefault(); this.prev(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', (e) => { e.preventDefault(); this.next(); });

    this.track.addEventListener('transitionend', () => this.#onTransitionEnd());

    // autoplay
    const speed = Number(this.getAttribute('autoplay')) || 0;
    if (speed > 0) {
      this.interval = window.setInterval(() => this.next(), speed * 1000);
      this.addEventListener('mouseenter', () => this.#pause());
      this.addEventListener('mouseleave', () => this.#resume());
      this.addEventListener('focusin', () => this.#pause());
      this.addEventListener('focusout', () => this.#resume());
    }

    // re-measure em resize / editor
    window.addEventListener('resize', () => {
      this.#syncHeight();
      this.#jumpTo(this.index);
    });
  }

  disconnectedCallback() {
    if (this.interval) window.clearInterval(this.interval);
  }

  prev() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.index -= 1;
    this.#animateTo(this.index);
  }

  next() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.index += 1;
    this.#animateTo(this.index);
  }

  #pause() {
    if (this.interval) window.clearInterval(this.interval);
    this.interval = null;
  }

  #resume() {
    const speed = Number(this.getAttribute('autoplay')) || 0;
    if (speed > 0 && !this.interval) {
      this.interval = window.setInterval(() => this.next(), speed * 1000);
    }
  }

  #syncHeight() {
    // mede o “maior” slide real (pra não cortar)
    const measureTargets = this.originalSlides.length ? this.originalSlides : this.slides;
    let max = 0;

    measureTargets.forEach(el => {
      // força display normal para medir corretamente
      const prev = el.style.display;
      el.style.display = '';
      const h = el.getBoundingClientRect().height;
      el.style.display = prev;
      if (h > max) max = h;
    });

    // fallback seguro
    if (!max || max < 16) max = 24;

    this.style.setProperty('--abv-height', `${Math.ceil(max)}px`);
  }

  #animateTo(i) {
    const h = this.viewport.getBoundingClientRect().height || 24;
    this.track.style.transition = 'transform 500ms ease';
    this.track.style.transform = `translate3d(0, ${-i * h}px, 0)`;
    this.#setAria(i);
  }

  #jumpTo(i) {
    const h = this.viewport.getBoundingClientRect().height || 24;
    this.track.style.transition = 'none';
    this.track.style.transform = `translate3d(0, ${-i * h}px, 0)`;
    this.#setAria(i);
  }

  #onTransitionEnd() {
    const totalReal = this.originalSlides.length;
    const lastRealIndex = totalReal;

    // se caiu no clone do último (topo)
    if (this.index === 0) {
      this.index = lastRealIndex;
      this.#jumpTo(this.index);
    }

    // se caiu no clone do primeiro (final)
    if (this.index === lastRealIndex + 1) {
      this.index = 1;
      this.#jumpTo(this.index);
    }

    this.isAnimating = false;
  }

  #setAria(i) {
    // deixa aria-hidden certo pra não “aparecer tudo” em leitores e evitar bugs de estilo
    this.slides.forEach((slide, idx) => {
      slide.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
    });
  }
}

customElements.define('announcement-bar-vertical', AnnouncementBarVertical);
